export const JtdJumpableIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="jtd-jumpable-icon"
    >
      <path
        d="M7 9C6.49036 9 5.92321 9.33617 5.92285 9.8457V18.1543C5.92308 18.6638 6.3362 19.077 6.8457 19.0771H15.1533C15.663 19.0771 16.0769 18.6639 16.0771 18.1543V18H17V18.1543C16.9998 19.1737 16.1728 20 15.1533 20H6.8457C5.8264 19.9998 5.00023 19.1736 5 18.1543V9.8457C5.00031 8.82632 5.98056 8 7 8V9ZM15.5 9C15.5043 9 15.5085 9.00088 15.5127 9.00098C15.6205 8.99881 15.7274 9.03419 15.8164 9.10547C15.9276 9.18885 16 9.31376 16 9.45508V13.5459C15.9997 13.7967 15.7759 13.9999 15.5 14C15.224 14 15.0003 13.7968 15 13.5459V10.6865L8.8125 16.8613C8.62428 17.0488 8.32157 17.0455 8.13672 16.8545C7.95219 16.6634 7.9547 16.3566 8.14258 16.1689L14.415 9.90918H11.5C11.224 9.90918 11.0003 9.70595 11 9.45508C11 9.204 11.2239 9 11.5 9H15.5ZM18 5C19.1046 5 20 5.89543 20 7V15C20 16.1046 19.1046 17 18 17H12.5C12.2239 17 12 16.7761 12 16.5C12 16.2239 12.2239 16 12.5 16H18C18.5523 16 19 15.5523 19 15V7C19 6.44772 18.5523 6 18 6H10C9.44772 6 9 6.44772 9 7V12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5V7C8 5.89543 8.89543 5 10 5H18Z"
        fill="#5B6372"
      />
    </svg>
  );
};
